import NewTruckFormComponent from './NewTruckFormComponent';
import { connect } from 'react-redux';
import { mapStateToProps } from './TruckFormContainer';
import { createTruck } from '../../store/actions/truck';
import { StoreState } from '../../store/state';

const mapDispatchToProps = {
  submit: createTruck.request,
};

export default connect(
  (state: StoreState) => ({
    ...mapStateToProps(state),
    templates: state.truckTemplate.templates,
  }),
  mapDispatchToProps,
)(NewTruckFormComponent);
